module.exports = "<div class=\"copyright\" wow-html-setting setting-group=\"Copyright\" setting-name=\"OnesiteCopyrightFooterHtml\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/copyright/copyright.component.html
// module id = 180
// module chunks = 1